module.exports = __webpack_public_path__ + "6b291147c111bc2c79e9acc1e9be1380.svg";